/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

export class NavUtils {

    public static openExternalLink(url: string, newWindow: boolean = true): void {
        window.open(url, newWindow ? "_blank" : "_self").focus();
    }

    public static closeWindow(): void {
        window.self.close();
    }
}
